/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  FileItem,
  ResourceSortType,
  Tags,
  TransitionState,
  UploadItems,
} from 'store/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import map from 'lodash-es/map';
import remove from 'lodash-es/remove';
import find from 'lodash-es/find';

const initialState: TransitionState = {
  uploadedFiles: {},
  avatarFile: {},
  globalModal: null,
  // TODO: если потребуется где то кроме поиска, обернуть в объект
  currentKeyHandlers: [],
};

export const transitionSlice = createSlice({
  name: 'transition',
  initialState,
  reducers: {
    setUploadedFiles: (state, action: PayloadAction<UploadItems>) => {
      state.uploadedFiles = action.payload;
    },
    setAvatarFile: (state, action: PayloadAction<UploadItems>) => {
      state.avatarFile = action.payload;
    },
    setGlobalModal: (
      state,
      action: PayloadAction<null | React.ReactElement>
    ) => {
      state.globalModal = action.payload;
    },
    addHandler: (state, action: PayloadAction<string>) => {
      const existing = find(state.currentKeyHandlers, (id) => {
        return action.payload === id;
      });

      // Один и тот же id дважды не регистрируем, чтобы не нарушить очередность
      if (existing) {
        return;
      }

      state.currentKeyHandlers = [...state.currentKeyHandlers, action.payload];
    },
    removeHandler: (state, action: PayloadAction<string>) => {
      const copy = [...state.currentKeyHandlers];
      remove(copy, (val) => val === action.payload);

      state.currentKeyHandlers = [...copy];
    },
  },
});

export const {
  setUploadedFiles,
  setGlobalModal,
  setAvatarFile,
  addHandler,
  removeHandler,
} = transitionSlice.actions;

export const selectUploadedFiles = (state: RootState) =>
  state.transition.uploadedFiles;
export const selectAvatarFile = (state: RootState) =>
  state.transition.avatarFile;
export const selectGlobalModal = (state: RootState) =>
  state.transition.globalModal;
export const selectTopKeyHandler = (state: RootState) => {
  return state.transition.currentKeyHandlers.slice(-1)[0];
};

export default transitionSlice.reducer;
